import { filecertPost } from "@/plugins/request";

export default {
  /**
   * 获取用户可登录的机构列表
   * @param {string} username 手机号/账号
   */
  getSiteList: (username) =>
    filecertPost(
      "/user/user/sitelist",
      { username },
      { headers: { token: "undefined" } }
    ),

  /**
   * 临床机构登录（multipart/form-data）
   * @param {{ username: string, password: string, site_id: number }} data
   */
  login: ({ username, password, site_id }) => {
    const form = new FormData();
    form.append("username", username);
    form.append("password", password);
    form.append("site_id", site_id);
    return filecertPost("/user/user/login", form, {
      headers: { token: "undefined" },
    });
  },

  /**
   * 机构端找回密码：发送手机验证码。
   * 通过统一登录页的 /filecert/ 反向代理转发到机构端后端。
   */
  sendResetCode: ({ mobile }) =>
    filecertPost(
      "/sms/send",
      { mobile, event: "resetpwd" },
      { headers: { token: "undefined" } }
    ),

  /**
   * 机构端找回密码：校验短信验证码并重置密码。
   */
  resetPasswordByCode: ({ mobile, captcha, password }) => {
    const form = new FormData();
    form.append("mobile", mobile);
    form.append("captcha", captcha);
    form.append("password", password);
    return filecertPost("/user/user/forgetpass", form, {
      headers: { token: "undefined" },
    });
  },
};
